<template>
    <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
        <div v-if="placeholder" class="alert alert-info">{{placeholder}}</div>
        <picture-input
                ref="pictureInput"
                :width="width"
                :height="width"
                :size="maxSize"
                :crop="crop"
                :prefill="preview"
                :prefillOptions="prefillOptions"
                margin="10"
                accept="image/jpeg,image/png"
                button-class="btn btn-sm btn-primary"
                :custom-strings="customStrings"
                @change="onFile">
        </picture-input>
    </b-form-group>
</template>

<script>
    import PictureInput from 'vue-picture-input'

    export default {
        components: {
            'picture-input': PictureInput
        },
        props: {
            model: Object,
            attribute: String,
            label: String,
            placeholder: String,
            errors: Array,
            baseUrl: String,
            maxSize: {
                type: Number,
                default: 30
            },
            width: {
                type: Number,
                default: 300
            },
            height: {
                type: Number,
                default: 300
            },
            crop: {
                type: Boolean,
                default: false
            },
            resize: {
                type: Boolean,
                default: true,
            },
            resizeWidth: {
                type: Number,
                default: 1000,
            },
            resizeHeight: {
                type: Number,
                default: 1000,
            },
            errorOnly: Boolean
        },
        data() {
            return {
                preview: this.model[this.attribute] ? (this.baseUrl + this.model[this.attribute]) : null,
                state: null,
                errorTxt: '',
                prefillOptions: {
                    mediaType: "image/jpeg"
                }
            }
        },
        watch: {
            model: {
                handler() {
                    this.state = null;
                    this.errorTxt = '';
                    this.preview = this.model[this.attribute] ? (this.baseUrl + this.model[this.attribute]) : null;
                }, deep: true
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {
            onFile(file) {
                let img = new Image();
                img.src = file;
                img.onload = () => {
                    if (this.resize) {
                        let canvas = document.createElement('canvas');
                        let width = img.width;
                        let height = img.height;

                        if (width > height) {
                            if (width > this.resizeWidth) {
                                height *= this.resizeWidth / width;
                                width = this.resizeWidth;
                            }
                        } else {
                            if (height > this.resizeHeight) {
                                width *= this.resizeHeight / height;
                                height = this.resizeHeight;
                            }
                        }
                        canvas.width = width;
                        canvas.height = height;
                        let ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);
                        file = canvas.toDataURL('image/jpeg');
                    }
                    let loader = this.$loading.show();
                    this.$service.post('/upload/image', {content: file}).then(response => {
                        this.model[this.attribute] = response.data;
                    }).finally(() => {
                        loader.hide();
                    });
                };

            },
        },
        mounted() {
            setTimeout(() => {
                this.$refs.pictureInput.onResize();
            }, 100);
        }
    }
</script>

<style>
    .picture-preview {
        z-index: 999 !important;
    }
</style>